
import { getListSupplier } from "redux/reducer/pharmacyStore";
import axiosClient from "./axiosClient";

const serviceUrl = '/qlttbhyt-service';

const shoppingService = {
  getListProposeShopping: async (params) => {
    const url = serviceUrl + `/de-nghi-mua-sam/searchKey`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDetailProposeShopping: async (id) => {
    const url = serviceUrl + `/de-nghi-mua-sam?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  createProposeShopping: async (data) => {
    const url = serviceUrl + `/de-nghi-mua-sam`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateProposeShopping: async (data, id) => {
    const url = serviceUrl + `/de-nghi-mua-sam?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteProposeShopping: async (id) => {
    const url = `${serviceUrl}/de-nghi-mua-sam/delete?id=${id}`;
    const response = await axiosClient.put(url);
    return response.data;
  },

  getListProposePay: async (params) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/searchKey`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDetailProposePay: async (id) => {
    const url = serviceUrl + `/de-nghi-thanh-toan?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  createProposePay: async (data) => {
    const url = serviceUrl + `/de-nghi-thanh-toan`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateProposePay: async (data, id) => {
    const url = serviceUrl + `/de-nghi-thanh-toan?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteProposePay: async (id) => {
    const url = `${serviceUrl}/de-nghi-thanh-toan/delete?id=${id}`;
    const response = await axiosClient.put(url);
    return response.data;
  },
  uploadChungTu: async (data) => {
    const url = `${serviceUrl}/upload-files`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.post(url, data, {
      headers: headers,
    });
    return response.data;
  },

  deleteHoSo: async (id) => {
    const url = `${serviceUrl}/delete-files?tenFile=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },

  approveListProposeShopping: async (data) => {
    const url = serviceUrl + `/de-nghi-mua-sam/phe-duyet-by-list-id`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  denyListProposeShopping: async (data) => {
    const url = serviceUrl + `/de-nghi-mua-sam/tu-choi-by-list-id`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  approveListProposePay: async (data) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/phe-duyet-by-list-id`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  denyListProposePay: async (data) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/tu-choi-by-list-id`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  // Catalog
  getListSupplier: async (params) => {
    const url = serviceUrl + `/danh-muc-nha-cung-cap`;
    const response = await axiosClient.get(url, {
      params: params

    });
    return response.data;
  },
  createSupplier: async (data) => {
    const url = serviceUrl + `/danh-muc-nha-cung-cap`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateSupplier: async (data) => {
    const url = serviceUrl + `/danh-muc-nha-cung-cap?id=${data?.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteSupplier: async (id) => {
    const url = serviceUrl + `/danh-muc-nha-cung-cap?id=${id}`;
    const response = await axiosClient.delete(url,);
    return response.data;
  },

  getListNguonNganSach: async (params) => {
    const url = serviceUrl + `/danh-muc-nguon-ngan-sach`;
    const response = await axiosClient.get(url, {
      params: params

    });
    return response.data;
  },
  createNguonNganSach: async (data) => {
    const url = serviceUrl + `/danh-muc-nguon-ngan-sach`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateNguonNganSach: async (data) => {
    const url = serviceUrl + `/danh-muc-nguon-ngan-sach?id=${data?.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteNguonNganSach: async (id) => {
    const url = serviceUrl + `/danh-muc-nguon-ngan-sach?id=${id}`;
    const response = await axiosClient.delete(url,);
    return response.data;
  },

  getListDuAn: async (params) => {
    const url = serviceUrl + `/danh-muc-du-an`;
    const response = await axiosClient.get(url, {
      params: params

    });
    return response.data;
  },
  createDuAn: async (data) => {
    const url = serviceUrl + `/danh-muc-du-an`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateDuAn: async (data) => {
    const url = serviceUrl + `/danh-muc-du-an?id=${data?.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteDuAn: async (id) => {
    const url = serviceUrl + `/danh-muc-du-an?id=${id}`;
    const response = await axiosClient.delete(url,);
    return response.data;
  },

  getListNguonThanhToan: async (params) => {
    const url = serviceUrl + `/danh-muc-nguon-thanh-toan`;
    const response = await axiosClient.get(url, {
      params: params

    });
    return response.data;
  },
  createNguonThanhToan: async (data) => {
    const url = serviceUrl + `/danh-muc-nguon-thanh-toan`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateNguonThanhToan: async (data) => {
    const url = serviceUrl + `/danh-muc-nguon-thanh-toan?id=${data?.id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteNguonThanhToan: async (id) => {
    const url = serviceUrl + `/danh-muc-nguon-thanh-toan?id=${id}`;
    const response = await axiosClient.delete(url,);
    return response.data;
  },

  // Xu ly file
  getListFileHoSo: async (params) => {
    const url = serviceUrl + `/list-files`;
    const response = await axiosClient.get(url, {
      params: params

    });
    return response.data;
  },

  getListTheoDoiThanhToan: async (id) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/lich-su-thanh-toan-dntt?idChiTietPhieu=${id}`;
    const response = await axiosClient.get(url,);
    return response.data;
  },
  createTheoDoiThanhToan: async (data) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/lich-su-thanh-toan-dntt`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  deleteTheoDoiThanhToan: async (id) => {
    const url = serviceUrl + `/de-nghi-thanh-toan/lich-su-thanh-toan-dntt?id=${id}`;
    const response = await axiosClient.delete(url,);
    return response.data;
  },

}

export default shoppingService;